module.exports = __webpack_public_path__ + "img/public/SiteIcons/steeringIcon.svg?a3c90025";